import { TStyles } from "utils/Styles";

const styles: TStyles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
    gap: 2.5,
  },
};

export default styles;
